import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./i18n";
import Login from "./auth/login"; // Ensure capitalization matches filename
import Passenger from "./pages/passenger";
import DriverLayout from "./pages/DriverLayout";
import DriverMap from "./pages/DriverMap";
import ProtectedRoute from "./auth/ProtectedRoute";
import MarketChat from "./components/MarketChat";

function App() {
  return (
    <Router>
      <Routes>
        {/* 1. Login (Public) */}
<Route path="/" element={<Login />} />

<Route path="/market-chat/:chatId" element={<MarketChat />} />
<Route
  path="/login"
  element={<Login />}
/>


        {/* 2. Passenger Protected Route */}
        <Route
          path="/passenger"
          element={
            <ProtectedRoute role="passenger">
              <Passenger />
            </ProtectedRoute>
          }
        />

        {/* 3. Driver Protected Routes (NESTED) */}
        {/* This handles both "/driver" and "/driver/map" */}
        <Route
          path="/driver"
          element={
            <ProtectedRoute role="driver">
              <DriverLayout />
            </ProtectedRoute>
          }
        >
          {/* These render INSIDE the DriverLayout <Outlet /> */}
          <Route index element={<DriverMap />} /> 
          <Route path="map" element={<DriverMap />} />
        </Route>

      </Routes>
    </Router>
  );
}

export default App;